/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/warning-alt': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#D49900" fill-rule="evenodd" d="M0 16h16L9 0H7L0 16zM7 5h2v5H7V5zm2 7H7v2h2v-2z" clip-rule="evenodd"/>'
  }
})
